
import { resetOpenStatesCache, stateName, stateNames, US_STATE_CODES } from '~/util/open-states'

export const OPEN_STATES_KEY = 'open-states'

// The list for the API: two-letter codes, upper-cased, known, unique, sorted.
export function cleanStates (list) {
    const codes = (Array.isArray(list) ? list : []).map(s => String(s || '').trim().toUpperCase()).filter(c => US_STATE_CODES.includes(c))
    return Array.from(new Set(codes)).sort()
}

export default {
    data () {
        return {
            loading: true,
            saving: false,
            form: { states: [] },
        }
    },
    computed: {
        stateOptions () {
            return US_STATE_CODES.map(code => ({ value: code, text: `${code} - ${stateName(code)}` }))
        },
        summary () {
            const states = cleanStates(this.form.states)
            return states.length ? `Open: ${stateNames(states)}` : 'No open states: non-paying clients cannot book on their own anywhere.'
        },
    },
    async mounted () {
        await this.load()
    },
    methods: {
        async load () {
            this.loading = true
            try {
                const setting = await this.$api.getSetting({ key: OPEN_STATES_KEY })
                this.form = { states: cleanStates(setting && setting.value && setting.value.states) }
            } catch (e) {
                this.toast(`Failed to load the open states: ${e.message || e}`, 'danger')
            }
            this.loading = false
        },
        async save () {
            this.saving = true
            try {
                const states = cleanStates(this.form.states)
                const setting = await this.$api.setSetting({ key: OPEN_STATES_KEY, value: { states } })
                this.form = { states: cleanStates(setting && setting.value && setting.value.states ? setting.value.states : states) }
                // The schedulers memoise the list per page load; make this tab refetch.
                resetOpenStatesCache()
                this.toast('Open states saved. They apply to the next booking.', 'success')
            } catch (e) {
                this.toast(`Failed to save the open states: ${e.message || e}`, 'danger')
            }
            this.saving = false
        },
        toast (message, variant) {
            if (this.$bvToast && this.$bvToast.toast) {
                this.$bvToast.toast(message, { variant })
            }
        },
    },
}
